import { BizError } from './biz-error';

export class ClientError extends BizError {}
